<template>
  <div class="contract-detail-bd">
    <div class="back-hd">
      <div class="back-fl">
        <i
          class="icon icon-fanhuijiantou"
          @click="jump($route.query.parentPath)"
        ></i>
        <span class="label">{{ $t('crm_contract_inv_trans_detail.bian_hao') }}：{{info.orderCode}}</span>
      </div>

      <div class="back-fr">
        <div class="handle">
          <el-dropdown
            @command="onCommand"
            style="vertical-align: top"
          >
            <el-button>
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 判断审批有3个条件： -->
              <!-- 1:后台配置的funcView -->
              <!-- 2:工单状态为审批中，即checkRole -->
              <!-- 3：调用接口判断用户是有对该工单有审批的资格 approvalAuth -->
              <el-dropdown-item
                v-if="
                funcView.contract_inventory_picking_approval &&
                  checkRole(info.orderState, FUNC_TYPES.APPROVAL) &&
                  approvalAuth.includes('APPROVE')
              "
                command="approval"
              >{{funcView.contract_inventory_picking_approval}}</el-dropdown-item>
              <el-dropdown-item
                v-if="
                funcView.contract_inventory_picking_nullify &&
                  checkRole(info.orderState, FUNC_TYPES.NULLIFY)
              "
                command="nullify"
              >{{funcView.contract_inventory_picking_nullify}}</el-dropdown-item>
              <el-dropdown-item
                v-if="funcView.contract_inventory_picking_service_receiving && checkReceiving(info)"
                command="receive"
              >{{funcView.contract_inventory_picking_service_receiving}}</el-dropdown-item>
              <el-dropdown-item
                v-if="funcView.contract_inventory_picking_deliver_goods && checkRole(info.orderState, FUNC_TYPES.DELIVER_GOODS) && checkDeliverGoods(info) && info.waitDeliver > 0"
                command="send"
              >{{funcView.contract_inventory_picking_deliver_goods}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="contract-about ub">
      <div class="ub-f1">
        <div class="company">
          <ul class="ub">
            <li>
              <h1>
                <i
                  class="icon icon-gongsi"
                  style="color: #0d9ae0"
                ></i>
                <span>{{ $t('crm_contract_inv_trans_detail.chu_ku_fang') }}</span>
              </h1>
              <p>{{info.outOrgName}}</p>
            </li>
            <li>
              <h1>
                <i
                  class="icon icon-gongsi"
                  style="color: #0d9ae0"
                ></i>
                <span>{{ $t('crm_contract_inv_trans_detail.ru_ku_fang') }}</span>
              </h1>
              <p>{{info.inOrgName}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contract-wrap ub">
      <!-- tab切换 -->
      <div class="ub-f1 ub-f0h">
        <div class="ubv">
          <custom-tab
            style="background-color: #ffffff"
            :list="tabList"
            v-model="tab"
          ></custom-tab>
          <inv-trans-info
            v-if="tab === 'invTransInfo'"
            :bizId="info.orderId"
          ></inv-trans-info>
          <inv-trans-device
            v-if="tab === 'device'"
            :bizId="info.orderId"
            :detail="info"
          ></inv-trans-device>
          <inv-trans-delivery-record
            v-if="tab === 'deliveryRecord'"
            :bizId="info.orderId"
          ></inv-trans-delivery-record>
          <!-- 发货计划 -->
          <contract-send-plan
            v-if="tab === 'sendPlan'"
            :detail="{bizId:info.orderId, orderClass: '90'}"
          ></contract-send-plan>
          <inv-trans-logistics-record
            v-if="tab === 'logisticsRecord'"
            :bizId="info.orderId"
          ></inv-trans-logistics-record>
        </div>
      </div>
      <!-- 合同动态 -->
      <div>
        <div class="wrap-aside">
          <div class="aside-title">
            <span>{{ $t('crm_contract_inv_trans_detail.tiao_bo_dong_tai') }}</span>
          </div>
          <empty-tips
            v-if="!flowList.length"
            height="200px"
          ></empty-tips>
          <div class="flow">
            <ul v-if="flowList.length">
              <li
                v-for="(item,index) in flowList"
                :key="index"
              >
                <div class="ub tit ub-xc">
                  <div class="dit1 dit">
                    <div></div>
                  </div>
                  <h1>{{ momentAmPm($momentLocal(item.operateTime)) }}</h1>
                </div>
                <div>
                  <p>{{ $t('crm_contract_inv_trans_detail.miao_shu') }}：{{item.content}}</p>
                  <p>{{ $t('crm_contract_inv_trans_detail.cao_zuo_ren') }}：{{item.userName}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 审批 -->
    <approval-dialog
      v-if="dialog1Visible"
      :model="dialog1Model"
      @close="dialog1Visible = false"
      @success="onUpdate"
    ></approval-dialog>
    <!-- 售后公司收货 -->
    <receive-goods-dialog
      v-if="dialog7Visible"
      @close="dialog7Visible = false"
      :model="dialog7Model"
      @success="onUpdate"
    ></receive-goods-dialog>
    <!-- 发货 -->
    <deliver-goods-dialog
      v-if="dialog4Visible"
      :model="dialog4Model"
      @close="dialog4Visible = false"
      @success="onUpdate"
    ></deliver-goods-dialog>
  </div>
</template>

<script>
// tab切换
import apis from '@/utils/apis';
import invTransInfo from './children/inv_trans_info.vue';
import invTransDevice from './children/inv_trans_device.vue';
import invTransDeliveryRecord from './children/inv_trans_delivery_record.vue';
import invTransLogisticsRecord from './children/inv_trans_logistics_record.vue';
import approvalDialog from './children/contract_approval_dialog';
import mixins from './mixins';
import receiveGoodsDialog from './children/receive_goods_dialog';
import deliverGoodsDialog from './children/deliver_goods_dialog';
import contractSendPlan from '../contractDetail/children/contract_send_plan.vue';

// 统一审批接口type
const type = 'transfer_order';

export default {
  mixins: [mixins],
  components: {
    invTransInfo,
    invTransDevice,
    invTransDeliveryRecord,
    invTransLogisticsRecord,
    contractSendPlan,
    approvalDialog,
    receiveGoodsDialog,
    deliverGoodsDialog,
  },
  name: '',
  computed: {
    workFlowType() {
      return type;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    tabList() {
      return [
        {
          name: this.$t('crm_contract_inv_trans_detail.tiao_bo_xin_xi'),
          value: 'invTransInfo'
        },
        {
          name: this.$t('crm_contract_inv_trans_detail.she_bei'),
          value: 'device'
        },
        {
          name: this.$t('crm_contract_inv_trans_detail.fa_huo_ji_lu'),
          value: 'deliveryRecord'
        },
        {
          name: this.$t('crm_contract_inv_trans_detail.fa_huo_ji_hua'),
          value: 'sendPlan',
        },
        {
          name: this.$t('crm_contract_inv_trans_detail.wu_liu_ji_lu'),
          value: 'logisticsRecord'
        }
      ];
    }
  },
  data() {
    return {
      provide: true,
      tab: 'invTransInfo',
      info: {},
      dialog1Model: {},
      dialog1Visible: false,

      // 发货
      dialog4Model: {},
      dialog4Visible: false,

      // 售后公司收货
      dialog7Visible: false,
      dialog7Model: {},

      // 调拨动态
      flowList: [],

      // 审批权限判断
      approvalAuth: [],
    };
  },
  mounted: function () {
    this.getPageInfo();
    this.getFuncView('/crmStock/contractInventoryPicking');

  },
  methods: {
    onUpdate() {
      this.getPageInfo().then(() => {
        this.Bus.$emit('update', this.info);
      });
    },
    // 判断是否有发货权限
    checkDeliverGoods(row) {
      if (this.userInfo) {
        /**
         * 组织类型：bas_org_type
           PF 平台  platform
           HQ 总部  factory
           SC 售后公司  service
           JV 代理公司  agent
           JV_SC 服务公司  agent_service
           CO 大客户  large_customer
           CS 租赁方  customer

           调拨单状态：crm_transfer_order_state
           1 草稿 draft
           6 审批中 ing
           10 审批通过 pass
           20 待发货 wait_ship
           21 在途中 on_the_way
           22 已收货 received
           80 已完成 finished
           90 审批拒绝 refuse
           100 已作废 abolished
         */
        if (row.outOrgId === this.userInfo.rootOrgId) {
          // 总部或者售后公司的状态为已完成的，应不显示发货操作
          if (this.userInfo && this.dicMap.bas_org_type && this.dicMap.crm_transfer_order_state) {
            const arr = [
              `${this.dicMap.bas_org_type.factory}`,
              `${this.dicMap.bas_org_type.service}`
            ];
            return !(arr.includes(this.userInfo.bizType) && `${this.dicMap.crm_transfer_order_state.finished}` === `${row.orderState}`);
          }
          return true;
        }
      }
      return false;
    },
    // 判断是否有收货权限
    checkReceiving(row) {
      if (this.userInfo) {
        return row.inOrgId === this.userInfo.rootOrgId && (this.dicMap.crm_transfer_order_state ? `${this.dicMap.crm_transfer_order_state.finished}` !== `${row.orderState}` : true);
      }
      if (this.dicMap.crm_transfer_order_state) {
        // 已完成和草稿不允许收货
        const statusFinish = `${this.dicMap.crm_transfer_order_state.finished}`;
        const statusDraft = `${this.dicMap.crm_transfer_order_state.draft}`;
        const orderState = `${row.orderState}`;
        return ![statusFinish, statusDraft].includes(orderState);
      }
      return false;
    },
    // 获取调拨动态
    getOrderLog() {
      const { orderId } = this.info;
      this.$getJSON(apis.transferOrderLog, { orderId }).then((res) => {
        this.flowList = res.data;
      });

    },
    getPageInfo() {
      const orderId = this.getJump('changeId');
      const bizId = orderId;
      const bizType = this.workFlowType;
      this.$postJSON(apis.apsApproveGetApproveAuth, {
        bizId: bizId,
        type: bizType
      }).then((ret) => {
        this.approvalAuth = ret.data || [];
      });

      return this.$getJSON(apis.transferOrderInfo, {
        orderId: orderId,
      }).then((res) => {
        this.info = res.data;
        this.getOrderLog();
      });
    },
    onCommand(command) {
      if (command === 'approval') {
        this.onApproval(this.info);
      }
      if (command === 'nullify') {
        this.onNullify(this.info);
      }
      if (command === 'receive') {
        this.receiveGoods(this.info);
      }
      if (command === 'send') {
        this.onDeliver(this.info);
      }
    },
    // 发货
    onDeliver(row) {
      this.dialog4Model = {
        title: this.i18n.dialog_title_deliver_goods,
        data: row,
      };
      this.dialog4Visible = true;
    },
    // 审批
    onApproval(row) {
      this.dialog1Model = {
        // 审批合同
        title: this.$t('crm_contract_inv_trans_detail.shen_pi_he_tong'),
        data: {
          ...row,
        },
        type: 'edit',
      };
      this.dialog1Visible = true;
    },
    // 作废
    onNullify(row) {
      this.$showConfirm(this.i18n.cf_tips_nullify_order).then(() => {
        const workFlowType = this.workFlowType;
        const bizId = row.orderId;
        this.$postJSON(`${apis.apsApproveApprovalCancel}/${workFlowType}/${bizId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.i18n.com_handle_success,
          });
          this.onUpdate();
        });
      });
    },
    receiveGoods(row) {
      this.dialog7Model = {
        data: row,
        title: this.i18n.dialog_title_service_company_receive,
      };
      this.dialog7Visible = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.contract-detail-bd {
  height: 100%;
  .back-hd {
    padding: 24px 16px 16px;
    .back-fl {
      height: 32px;
      line-height: 32px;
      display: inline-block;
      .icon {
        color: #394668;
        font-size: 18px;
        font-weight: bold;
        margin-left: 4px;
        margin-right: 16px;
        cursor: pointer;
      }
      span {
        color: #394668;
        font-size: 18px;
        font-weight: 500;
      }
    }
    .back-fr {
      float: right;
    }
  }
  .contract-about {
    margin: 0 16px;
    padding: 19px 0;
    height: 88px;
    background-color: #ffffff;
    .name {
      padding-left: 20px;
      padding-top: 20px;
      height: 60px;
      .icon {
        font-size: 20px;
        line-height: 28px;
        margin-right: 16px;
      }
      h1 {
        font-size: 15px;
        color: $title-color;
        line-height: 28px;
        height: 28px;
        font-weight: bold;
      }
    }
    .company {
      padding-left: 20px;
      ul > li {
        min-width: 230px;
        height: 50px;
        padding-left: 24px;
        padding-right: 50px;
        border-right: 1px solid #e9ebec;
        &:last-child {
          border-right: none;
        }
        h1 {
          font-size: 12px;
          color: #495057;
          font-weight: 500;
          line-height: 26px;
          .icon {
            font-size: 18px;
            margin-right: 6px;
            float: left;
          }
        }
        p {
          line-height: 24px;
          color: #6c757d;
          font-size: 12px;
        }
      }
    }
    .company-aside {
      padding-right: 24px;
      .handle {
        padding: 20px 0 0 80px;
        height: 66px;
      }
      .item {
        text-align: right;
        margin-left: 50px;
        h2 {
          color: #6c757d;
          font-size: 12px;
          line-height: 18px;
          height: 18px;
          margin-bottom: 6px;
        }
        p {
          color: #495057;
          font-size: 16px;
          font-weight: 500;
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
  .contract-wrap {
    padding: 16px;
  }
  .wrap-aside {
    width: 350px;
    background-color: #ffffff;
    margin-left: 20px;
    padding-bottom: 10px;
    .aside-title {
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
      color: #495057;
      font-weight: 500;
      font-size: 12px;
      border-bottom: 1px solid #eef2f8;
      margin-bottom: 10px;
    }
    .flow {
      padding: 25px 0 25px 32px;
      height: 760px;
      overflow-y: auto;
      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
